<div class="modal-header">
  <span class="modal-title">ADD NEW CUSTOMER</span>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" [formGroup]="customerForm">
  <div>
    <div class="kt-portlet__head-title kt-margin-b-25">
      CUSTOMER DETAILS
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Name</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="name">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Recipient Name</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="recipientName">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Phone number</div>
      <div class="customer-option__value">
        <input type="text" class="form-control w-50" formControlName="phoneNumber">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Email</div>
      <div class="customer-option__value"
        [class.has-error]="!customerForm.get('email').valid && (customerForm.get('email').dirty || customerForm.get('email').touched)">
        <input type="text" class="form-control w-50" formControlName="email">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Address</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="address1">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Appartment, Suite, Etc.</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="address2">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">City</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="city">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">District</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="district">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">County</div>
      <div class="customer-option__value">
        <input type="text" class="form-control" formControlName="county">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Country/Region</div>
      <div class="customer-option__value">
        <select class="form-control w-50" formControlName="countryCode">
          <option *ngFor="let country of countries.list" [value]="country">
            {{ 'COUNTRIES.' + country + '.NAME' | translate }}
          </option>
        </select>
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">State/Province</div>
      <div class="customer-option__value ">
        <select class="form-control w-50" formControlName="state" *ngIf="countries.getStates(customerForm.value.countryCode).length">
          <option *ngFor="let state of countries.getStates(customerForm.value.countryCode)" [value]="state">
            {{ 'COUNTRIES.' + customerForm.value.countryCode + '.STATES.' + state | translate }}
          </option>
        </select>
        <input type="text" class="form-control" formControlName="stateCode" *ngIf="countries.getStates(customerForm.value.countryCode).length === 0">
      </div>
    </div>
    <div class="customer-option">
      <div class="customer-option__title content-text-13-grey-1">Zip Code</div>
      <div class="customer-option__value">
        <input type="text" class="form-control w-25" formControlName="postalCode">
      </div>
    </div>
  </div>
</div>
<div class="modal-footer d-flex">
  <div>
    <button class="btn btn-secondary bg-white" (click)="modal.dismiss()">
      {{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
    <button class="btn btn-brand kt-margin-l-15" (click)="save()">
      {{ 'GENERAL.BUTTONS.ADD' | translate }}</button>
  </div>
</div>
<loading [loading]="loading"></loading>